export default __webpack_public_path__ + "static/media/Deutsche_Krankenhausgesellschaft_logo.d4495a76.svg";